import { ColorType } from './../modal-select-dialog/modal-select-dialog.service';
import { Component, OnInit, OnDestroy, HostBinding, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ColorPickerDialogService, ColorPickerParams, PaletteLimits } from './color-picker-dialog.service';

import { HexString } from 'src/app/types/@types/hex-string';
import { ViewStackComponent } from '../../view-stack/view-stack.component';
import { StatefulCSS } from 'src/app/model/stateful_css';
declare var KellyColorPicker: any;
@Component({
  selector: 'app-color-picker-dialog',
  templateUrl: './color-picker-dialog.component.html',
  styleUrls: ['./color-picker-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorPickerDialogComponent implements OnInit {
  public title = 'Color Selector';
  private params: ColorPickerParams;
  private picker: any;
  public nextColor: HexString = '7c00ff';

  public color: HexString = '#7c00ff';
  public colorFor: string;
  @HostBinding('class.work-view') workView = true;
  @ViewChild('colorViews', { static: true }) colorViews: ViewStackComponent;
  @ViewChild('colorList', { static: true }) colorList: ElementRef;
  @ViewChild('ui', { static: true }) ui: ElementRef;
  @ViewChild('colorCode', { static: true }) colorCode: ElementRef;

  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef) { }

  private lastUp = 0;
  private xlsStyleMgr: StatefulCSS;

  private keyBounceDelay = 500;
  private _defaultLimits: PaletteLimits = { wheel: ['xls', 'legacy', 'wheel'], legacy: ['xls', 'legacy', 'wheel'], xls: ['xls'] };
  private _initView: ColorType;

  ngOnInit() {
    if (this.params.color !== '') this.color = this.params.color;
    this.colorViews.ready.subscribe(() => {
      switch (this.params.type) {
        case 'legacy':
          this.ToLegacy(this.color);
          this.colorViews.SetView('legacy');

          return;
        case 'xls':
          this.ToXLS(this.color);
          this.colorViews.SetView('xls');
          break;
        default:
        case 'wheel':
          this.ToLegacy(this.color);

          this.colorViews.SetView('wheel');
          break;

      }
      this.cdr.detectChanges();
    })

    ///if (!this.params.type) {
    this.colorViews.SetView(this.params.type);
    //}
    this.picker = new KellyColorPicker({
      place: this.ui.nativeElement,
      color: this.color,
      userEvents: {
        change: this.HandlePickerColor.bind(this)
      }
    });
    this.xlsStyleMgr = new StatefulCSS();
    this.xlsStyleMgr.SetPrefix('xls-');
    this.xlsStyleMgr.AddState('black');
    this.xlsStyleMgr.AddState('blue');
    this.xlsStyleMgr.AddState('cyan');
    this.xlsStyleMgr.AddState('green');
    this.xlsStyleMgr.AddState('magenta');
    this.xlsStyleMgr.AddState('red');
    this.xlsStyleMgr.AddState('white');
    this.xlsStyleMgr.AddState('yellow');
    this.xlsStyleMgr.SetMachine(this.colorList.nativeElement);
    this.cdr.detectChanges();
  }
  HandlePickerColor(picker: any) {
    this.color = picker.getCurColorHex();
    this.nextColor = this.color.replace('#', '');
    this.cdr.detectChanges();

  }
  KeyUp(_e: any) {
    this.lastUp = Date.now();
    this.UpdateColor();
    this.cdr.detectChanges();
  }
  KeyDown(_e: any) {
    this.lastUp = Date.now();
    this.cdr.detectChanges();

  }

  UpdateColor(isNew: boolean = true) {

    window.requestAnimationFrame(() => {
      if (Date.now() - this.lastUp < this.keyBounceDelay) {
        this.UpdateColor(false);
      } else {
        this.picker.setColorByHex(this.colorCode.nativeElement.value);
        this.lastUp = 0;

      }
      this.cdr.detectChanges();
    });
  }
  public xlsHexCode: string = '#000000';
  SetXLS(xlsColor, hexColor) {
    this.color = xlsColor;
    this.xlsHexCode = hexColor;
    this.cdr.detectChanges();

  }
  Show(params: ColorPickerParams) {
    this.params = params;
    this.colorFor = !!params.colorFor ? params.colorFor : '';
    this.colorCode.nativeElement.focus();
    this.colorCode.nativeElement.select();
    if (!this.params.type) {
      this.params.type = 'wheel';
    }
    this._initView = this.params.type as ColorType;
    if (!this.params.limits) {
      this.params.limits = this._defaultLimits;
    }
    this.cdr.detectChanges();

  }
  IsLimited(which: ColorType): boolean {
    if (!this._initView) return true;
    if (!(this.colorViews?.currentView?.viewName)) return true;
    if (this.colorViews.currentView.viewName === which) return true;
    if (!!this.params.limits) {
      return this.params.limits[this._initView].indexOf(which) === -1;
    }
    return false;
  }
  SetView(which: ColorType) {
    switch (which) {
      case 'legacy':
        this.ToLegacy(this.color);
        break;
      case 'xls':
        this.ToXLS(this.color);
        break;
      case 'wheel':
        this.ToLegacy(this.color);
        this.nextColor = this.color
        this.lastUp = Date.now();
        this.UpdateColor();
        break;

    }
    this.colorViews.SetView(which);
    this.cdr.detectChanges();
  }
  Ok() {
    this.colorViews.currentView;
    if ( !this.IsLimited('legacy') || !this.IsLimited('wheel')) {
      this.ToLegacy(this.color);
    }
    this.params.handler(this.color);
    this.params = null;
    this.activeModal.close();
  }
  Cancel() {
    this.params = null;
    this.activeModal.close();
  }
  ToLegacy(color: string) {
    switch (color) {
      case 'Black':
        color = '#000000';
        break;
      case 'Blue':
        color = '#0000FF';
        break;
      case 'Cyan':
        color = '#00B7EB';
        break;
      case 'Magenta':
        color = '#D0417E';
        break;
      case 'Red':
        color = '#FF0000';
        break;
      case 'White':
        color = '#FFFFFF';
        break;
      case 'Yellow':
        color = '#FFFF00';
        break;
      case 'Green':
        color = '#00FF00';
        break;
      default:
        if (color.substring(0, 1) !== '#') {
          color = '#' + color;
        }
        if (color.length === 4) {
          color = color.replace(/\#(.)(.)(.)/, "#$1$1$2$2$3$3");
        }
        break;
    }
    this.color = color;
    this.cdr.detectChanges();

  }
  ToWheel(color: string) {
    this.ToLegacy(color);
  }
  ToXLS(color: string) {
    switch (color) {
      case 'Black':
      case 'Blue':
      case 'Cyan':
      case 'Magenta':
      case 'Red':
      case 'White':
      case 'Yellow':
        // do nothing
        return;
      case '#000':
      case '#000000':
        this.color = 'Black';
        this.xlsHexCode = '#000000';
        return;
      case '#00F':
      case '#0000FF':
        this.color = 'Blue';
        this.xlsHexCode = '#0000FF';
        return;
      case '#00B7EB':
      case '#00FFFF':
      case '#0FF':
        this.color = 'Cyan';
        this.xlsHexCode = '#00B7EB';
        return;
      case '#D0417E':
      case '#F0F':
      case '#FF00FF':
        this.color = 'Magenta';
        this.xlsHexCode = '#D0417E';
        return;
      case '#F00':
      case '#FF0000':
        this.color = 'Red';
        this.xlsHexCode = '#FF0000';
        return;
      case '#FFF':
      case '#FFFFFF':
        this.color = 'White';
        this.xlsHexCode = '#FFFFFF';
        return;
      case '#FF0':
      case '#FFFF00':
        this.color = 'Yellow';
        this.xlsHexCode = '#FFFF00';
        return;
      default:
        if ('#123456789'.indexOf(color.substr(0, 1)) !== -1) {
          this.color = 'Black';
          return;
        }
    }
  }
}

@Component({
  selector: 'app-color-picker-dialog-entry',
  template: ''
})
export class ColorPickerDialogEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: ColorPickerDialogService) {

    this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
      this.modalRef = this.modalService.open(ColorPickerDialogComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as ColorPickerDialogComponent).Show(info);
    });
  }
  ngOnDestroy(): void {
    this.subscriptionMgr.CancelSubscriptions();
  }
}
